import { makeAutoObservable } from 'mobx'
import * as apiClient from 'src/utils/apiClient/paymentMethods'

export default class PaymentMethodStore {
  // Constructor ------------

  constructor() {
    makeAutoObservable(this)
  }

  // Actions ---------------

  getAccountTransferEditParams = async (userId: number) => {
    return await apiClient.getAccountTransferEditParams(userId)
  }

  getCreditCardEditURL = async (userId: number) => {
    const { url } = await apiClient.getCreditCardEditURL(userId)
    return url
  }
}
